//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    var $el = this;
    return {
      reportId: '',
      reportType: '',
      reportComponent: '',
      reportTable: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    var $el = this;
    Event.$on('global-defaults-reporting', function (report) {
      Object.assign(_this, report);
      $el.$children[0].$data.showModal = true;
    });
    Event.$on('export-report', this.exportReport);
  },

  methods: {
    exportReport: function exportReport(data) {
      axios.post('/prototype/reporting/export-report', data).then(function (response) {
        if (response.data) {
          var url = window.URL.createObjectURL(new Blob([response.data]));
          var link = document.createElement('a');
          link.href = url;

          var filename = data.type + ' - ' + localStorage.getItem('property-name');

          if (data.start_date) {
            filename = filename + ' - ' + moment(data.start_date).format('YYYYMMDD');
            filename = filename + '-' + moment(data.end_date).format('YYYYMMDD');
          }
          filename = filename + ' - ' + moment().format('YYYY-MM-DD') + '.csv';

          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    Event.$off('global-defaults-reporting');
    Event.$off('export-report');
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reporting/GlobalDefaultReport.vue
// module id = 3SSO
// module chunks = 0 1